(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snzc-cro-buybox"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__snzOfferEngine) return;
  window.__snzOfferEngine = true;
  const config = () => document.querySelector('[data-snz-config]')?.dataset || {};
  const root = () => window.Shopify?.routes?.root || '/';
  const sectionNames = () => [...new Set(['cart-drawer','cart-icon-bubble', document.querySelector('#main-cart-items')?.dataset.id, document.querySelector('#main-cart-footer')?.dataset.id].filter(Boolean))];
  const post = async (endpoint, body) => {
    const response = await fetch(root() + endpoint, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({...body,sections:sectionNames(),sections_url:location.pathname})});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : config().error);
    return data;
  };
  const show = data => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && data.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
      if (typeof drawer.open === 'function') drawer.open();
    } else location.assign(config().cartUrl || root()+'cart');
  };
  document.addEventListener('change', async event => {
    const input = event.target.closest('cart-items input[name="updates[]"]');
    if (!input || !document.body.classList.contains('snz24-cart')) return;
    event.stopImmediatePropagation();
    const cartItems = input.closest('cart-items');
    if (cartItems.dataset.snzPending) return;
    const quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 1) { input.value = input.dataset.cartQuantity; return; }
    cartItems.dataset.snzPending = 'true';
    cartItems.setAttribute('aria-busy','true');
    const focusId = input.id;
    const controls = Array.from(document.querySelectorAll('#MainContent button, cart-items input[name="updates[]"]')).map(control => [control,control.disabled]);
    controls.forEach(([control]) => { control.disabled = true; });
    try {
      const data = await post('cart/change.js',{line:Number(input.dataset.index),quantity});
      const parser = new DOMParser();
      const itemsId = document.querySelector('#main-cart-items').dataset.id;
      const footer = document.querySelector('#main-cart-footer');
      const itemsHtml = data.sections?.[itemsId];
      const footerHtml = data.sections?.[footer.dataset.id];
      const freshItems = itemsHtml && parser.parseFromString(itemsHtml,'text/html').querySelector('cart-items');
      const freshFooter = footerHtml && parser.parseFromString(footerHtml,'text/html').querySelector('#main-cart-footer');
      if (!freshItems || !freshFooter) { location.reload(); return; }
      cartItems.innerHTML = freshItems.innerHTML;
      cartItems.classList.toggle('is-empty',data.item_count===0);
      footer.innerHTML = freshFooter.innerHTML;
      footer.classList.toggle('is-empty',data.item_count===0);
      const iconHtml = data.sections?.['cart-icon-bubble'];
      const icon = document.querySelector('#cart-icon-bubble');
      const iconDocument = iconHtml && parser.parseFromString(iconHtml,'text/html');
      const freshIcon = iconDocument && (iconDocument.querySelector('#cart-icon-bubble') || iconDocument.querySelector('.shopify-section') || iconDocument.body);
      if (icon && freshIcon) icon.innerHTML = freshIcon.innerHTML;
      document.getElementById(focusId)?.focus();
    } catch(error) {
      input.value = input.dataset.cartQuantity;
      const status = document.querySelector('#cart-errors');
      if (status) { status.setAttribute('role','alert'); status.textContent = error.message || config().error; }
    } finally {
      delete cartItems.dataset.snzPending;
      cartItems.removeAttribute('aria-busy');
      controls.forEach(([control,disabled]) => { control.disabled = disabled; });
    }
  },true);
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-snz-packs] input[type="radio"]');
    if (!input) return;
    const fieldset = input.closest('[data-snz-packs]');
    fieldset.querySelector('[data-snz-quantity]').value = input.dataset.quantity;
    const variant = fieldset.closest('form').querySelector('[name="id"]');
    if (input.dataset.variant) {
      if (!fieldset.dataset.setActive) fieldset.dataset.baseId = variant.value;
      fieldset.dataset.setActive = 'true';
      variant.value = input.dataset.variant;
    } else if (fieldset.dataset.setActive) {
      variant.value = fieldset.dataset.baseId;
      delete fieldset.dataset.setActive;
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form');
    const fieldset = form?.querySelector('[data-snz-packs]');
    if (!fieldset) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (form.dataset.snzPending) return;
    form.dataset.snzPending='true';
    const button = form.querySelector('button[type="submit"]');
    const status = fieldset.querySelector('[data-snz-status]');
    if (button) button.disabled=true;
    form.setAttribute('aria-busy','true');status.textContent=config().busy;
    try {
      const fields = new FormData(form);
      const selection = fieldset.querySelector('input[type="radio"]:checked');
      const item = {id:Number(selection.dataset.variant || fields.get('id')),quantity:Number(selection.dataset.quantity)};
      const data = await post('cart/add.js',{items:[item]});
      status.textContent=config().added;show(data);
    } catch(error) {status.textContent=error.message || config().error;}
    finally {delete form.dataset.snzPending;form.removeAttribute('aria-busy');if(button)button.disabled=false;}
  },true);
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-snz-add],[data-snz-upgrade]');
    if(!button || button.disabled) return;
    event.preventDefault();button.disabled=true;
    const box=button.closest('.snzo-cart-offer');
    const status=box.querySelector('[data-snz-status]');status.textContent=config().busy;
    try {
      let data;
      if (button.hasAttribute('data-snz-upgrade')) {
        const cartResponse=await fetch(root()+'cart.js',{headers:{'Accept':'application/json'}});
        if(!cartResponse.ok)throw new Error(config().error);
        const cart=await cartResponse.json();
        const line=cart.items.find(item=>item.key===button.dataset.key);
        if(!line || line.quantity!==1)throw new Error(config().error);
        data=await post('cart/update.js',{updates:{[line.key]:0,[button.dataset.variant]:1}});
      } else data=await post('cart/add.js',{items:[{id:Number(button.dataset.snzAdd),quantity:1}]});
      if(document.body.classList.contains('snz24-cart'))location.reload();else show(data);
    } catch(error) {status.textContent=error.message || config().error;button.disabled=false;}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
